import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';

import './ModalLink.scss';

import { openModal as openModalAction } from '../../../../redux/modules/modals/modals.module';

const ModalLink = ({
  className,
  link,
  linkStyle = 'none',
  modalName,
  openModal,
  modalProps,
}) => (
  <a
    onClick={() => openModal(modalName, modalProps)}
    className={`modal-link modal-link-${linkStyle} modal-link-${
      className ? className : ''
    }`}
  >
    {link}
  </a>
);

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ openModal: openModalAction }, dispatch);

export default compose(connect(mapStateToProps, mapDispatchToProps))(ModalLink);
